import type { ModalConfig } from "./types";

export const communicationModalsModalUrlConfig = {
  // Communication Modals
  "communications-detail": {
    modalId: "communications-detail",
    entityName: "communications",
    singularParam: "communicationId",
    pluralParam: "communicationsId",
    displayName: "Communication",
  },
  "create-communications": {
    modalId: "create-communications",
    entityName: "communications",
    singularParam: "communicationId",
    pluralParam: "communicationsId",
    displayName: "Communication",
  },
  "edit-communications": {
    modalId: "edit-communications",
    entityName: "communications",
    singularParam: "communicationId",
    pluralParam: "communicationsId",
    displayName: "Communication",
  },
} as const satisfies Record<string, ModalConfig>;
